<template>
  <div class="review_rw" :class="{ [curTheme]: true }" v-if="reviews">

    <template v-if="reviews.length">
      <div class="rw_item" v-bind:class = "reviewClass(r)"
        v-for="(r, i) in reviews" :key="`review-${i}`" >
        <div class="rw_inner-wrap">
          <div v-if="r.Type == 'review'" class="rw-grade"></div>
          <div class="rw_author">
            <router-link
              class="author-link"
              :to="`/user/${r.Author.UserId}/profile/view`">
              {{ fio(r.Author) }}
            </router-link>
          </div>
          <template v-if="isAuthenticated">
            <el-tooltip
              v-if="canDeleteReview(r.Transient)"
              :content="'Удалить ' + (r.Type === 'review' ? 'отзыв' : 'комментарий')"
              placement="top">
              <button class="rw-delete"
                @click="showManageDialog(r, 'delete')">
              </button>
            </el-tooltip>
            <el-tooltip
              v-if="canUpdateReview(r.Transient)"
              :content="'Редактировать ' + (r.Type === 'review' ? 'отзыв' : 'комментарий')"
              placement="top">
              <button class="rw-edit"
                @click="showManageDialog(r, 'edit')">
              </button>
            </el-tooltip>
            <claim-add
              v-if="isAuthenticated && canClaimReview(r.Transient)"
              class="rw_claim-add"
              :entity-type="getReviewType(r)"
              :entity-id="r.ReviewId"/>
          </template>
          <div class="rw_date">{{ date(r.CreatedTime) }}</div>
        </div>
        <div class="rw-content">

        <template v-if="r.Type == 'review'">
            <div class="rw-likes-control">

              <template v-if="canRateReview(r)">
                <el-tooltip content="-1" placement="top">
                  <button class="rw-set-dislike"
                    v-bind:class="{send_relation_wait : activeRelationButton === i}"
                    :disabled="sendingToApi" @click="submitReviewRelation(r.ReviewId, -1, i)">
                    </button>
                </el-tooltip>
                <div class="rw-likes-count" v-bind:class="reviewRatingClass(r)">
                  {{ reviewRating(r) }}
                </div>
                <el-tooltip content="+1" placement="top">
                  <button class="rw-set-like"
                    v-bind:class="{send_relation_wait : activeRelationButton === i}"
                    :disabled="sendingToApi" @click="submitReviewRelation(r.ReviewId, 1, i)">
                    </button>
                </el-tooltip>
              </template>

              <template v-else>
                <div class="rw-likes-count no-likes-control" v-bind:class="reviewRatingClass(r)">
                  {{ reviewRating(r) }}
                </div>
              </template>

            </div>
          </template>

          <div class="rw_text" v-html="reviewFormatText(r.Text)"></div>

          <template v-if="r.Type == 'comment' && canAnswerComment(r)">
            <button
              @click="addCommentAnswer(r)"
              class="btn-answer-comment">Написать ответ</button>
          </template>

          <template v-else-if="r.Type == 'comment' && typeof r.Transient.Answer !== 'undefined'">
            <div class="comment-answer">
             <div class="rw_author">
                <span
                  @click="$router.push(
                    { path: `/user/${r.Transient.Answer.AuthorId}/profile/view` })"
                  class="author-link">{{ r.Transient.Answer.Author }}</span>
              </div>
              <template v-if="isAuthenticated">
                <el-tooltip
                  v-if="canDeleteReview(r.Transient.Answer)"
                  content="Удалить ответ на комментарий"
                  placement="top">
                  <button class="rw-delete"
                    @click="showManageDialog(r.Transient.Answer, 'delete')">
                  </button>
                </el-tooltip>
                <el-tooltip
                  v-if="canUpdateReview(r.Transient.Answer)"
                  content="Редактировать ответ на комментарий"
                  placement="top">
                    <button class="rw-edit"
                      @click="showManageDialog(r.Transient.Answer, 'edit')">
                    </button>
                </el-tooltip>

                <claim-add
                  v-if="isAuthenticated && canClaimReview(r.Transient.Answer)"
                  class="rw_claim-add"
                  entity-type="Comment"
                  :entity-id="r.Transient.Answer.ReviewId"/>
              </template>
              <div class="rw_date">
                {{ date(r.Transient.Answer.CreatedTime) }}
              </div>
              <div class="rw_text" v-html="reviewFormatText(r.Transient.Answer.Text)"></div>
            </div>
          </template>
        </div>
      </div>

      <el-dialog v-if="this.isObjectAuthor"
        class="rs_popup_rp"
        :visible.sync="answerPopup.showAnswerPopup">
        <h2 class="rp_header">
          Ответ на комментарий
        </h2>
        <div class='block-wrap rs_block-wrap comment-question'>
          Комментарий:
          <div
            v-if="answerPopup.questionText"
            v-html="reviewFormatText(answerPopup.questionText)">
          </div>
        </div>
        <app-inputs ref="inputs">
          <div class="block-wrap rs_block-wrap">
            <app-input
              widget="AppText"
              ref="reviewText"
              :options="{ name: 'reviewText', title: 'Ответ', required: true, autosize: true }"/>
          </div>
          <div class="block-wrap rs_block-wrap">
            <app-input
              widget="AppPasswordSimple"
              :options="{ name: 'password', title: 'Введите ваш пароль', required: true }"/>
          </div>
          <div class="buttons-wrap">
            <button :disabled="sendingToApi" class="vivid-button" @click="submitCommentAnswer">
              Отправить
            </button>
          </div>
        </app-inputs>
      </el-dialog>

      <el-dialog
        class="rs_popup_rp"
        :visible.sync="manageReview.deleteDialogVisible">
        <h2 class="rp_header">
          Удалить {{ manageReview.TypeName }}
        </h2>
          <div class="block-wrap rs_block-wrap dialog-message">
            Вы действительно хотите удалить {{ manageReview.TypeName }}?
            <div
              v-if="manageReview.Text"
              v-html="reviewFormatText(manageReview.Text)">
            </div>
          </div>
          <div class="buttons-wrap">
            <button
              :disabled="sendingToApi"
              class="vivid-button"
              @click="deleteReview">
              Удалить
            </button>
            <button
              :disabled="sendingToApi"
              class="vivid-button"
              @click="manageReview.deleteDialogVisible = false">
              Закрыть окно
            </button>
          </div>
      </el-dialog>

      <el-dialog
        class="rs_popup_rp"
        :visible.sync="manageReview.editDialogVisible">
        <h2 class="rp_header">
          Редактировать {{ manageReview.TypeName }}
        </h2>
        <app-inputs ref="inputs">
          <div class="block-wrap rs_block-wrap dialog-message">
            <app-input
              widget="AppText"
              ref="reviewText"
              :options="{ name: 'reviewText', title: 'Текст', required: true, autosize: true }"/>

            <template v-if="manageReview.Type === 'review'">
              <app-input
                widget="AppRate"
                ref="reviewGrade"
                :options="{ name: 'reviewGrade', title: 'Оцените объект', required: true }"/>
            </template>
          </div>
          <div class="buttons-wrap">
            <button
              :disabled="sendingToApi"
              class="vivid-button"
              @click="updateReview">
              Сохранить
            </button>
          <button
            class="vivid-button"
            :disabled="sendingToApi"
            @click="manageReview.editDialogVisible = false">
            Закрыть окно
          </button>
          </div>
        </app-inputs>
      </el-dialog>
    </template>

    <template v-else>
      <div class="rw_no-reviews text-center">{{ emptyMessage }}</div>
    </template>

  </div>
</template>

<script>
import axios from 'axios';
import ClaimAdd from '@/components/ClaimAdd';
import AppFieldWidget from '../AppFieldWidget';
import Misc from '../../mixins/Misc';
import AppMessages from '../AppMessages';
import AppInputs from '../inputs/AppInputs';
import AppInput from '../inputs/AppInput';

export default {

  mixins: [Misc],

  components: { AppFieldWidget, AppMessages, AppInputs, AppInput, ClaimAdd },

  props: {
    reviews: null,
    emptyMessage: '',
    objectCreatorId: '',
  },

  data() {
    return {
      manageReview: {
        deleteDialogVisible: false,
        editDialogVisible: false,
        ReviewId: '',
        ObjectId: '',
        Type: '',
        TypeName: '',
        Grade: '',
        ParentReviewId: '',
      },
      activeRelationButton: null,
      sendingToApi: false,
      answerPopup: {
        objectId: '',
        questionId: '',
        questionText: '',
        showAnswerPopup: false,
      },
    };
  },

  computed: {

    isAuthenticated() {
      return this.$store.getters['user/isAuthenticated'];
    },

    getUserId() {
      const userId = this.$store.getters['user/getUserId'];
      if (userId) return userId;
      return 0;
    },

    isObjectAuthor() {
      if (this.getUserId === this.objectCreatorId) return true;
      return false;
    },
  },

  methods: {

    canDeleteReview(review) {
      if (review.Permissions.REVIEW_DELETE === true) return true;
      return false;
    },

    canUpdateReview(review) {
      if (review.Permissions.REVIEW_UPDATE === true) return true;
      return false;
    },

    canClaimReview(review) {
      if (review.Permissions.CLAIM_CREATE === true) return true;
      return false;
    },

    fio(a) {
      const fio = [];
      if (a.Surname) fio.push(a.Surname);
      if (a.Name) fio.push(a.Name);
      if (a.Patronymic) fio.push(a.Patronymic);
      return fio.join(' ');
    },

    reviewClass(review) {
      if (review.Type === 'comment') return 'rw-comment';
      else if (review.Type === 'review') {
        if (review.Grade === 1) return 'rw-positive';
        return 'rw-negative';
      }
      return '';
    },

    reviewRatingClass(review) {
      const rating = this.reviewRating(review);
      if (rating === 0) return 'neutral-review-rating';
      else if (rating > 0) return 'positive-review-rating';
      else if (rating < 0) return 'negative-review-rating';
      return '';
    },

    reviewRating(review) {
      if (typeof review.Transient.LikesNumber !== 'undefined'
        && typeof review.Transient.DislikesNumber !== 'undefined') return review.Transient.LikesNumber - review.Transient.DislikesNumber;
      return 0;
    },

    reviewFormatText(text) {
      return text.replace(/\n/g, '<br />');
    },

    canRateReview(review) {
      if (!this.getUserId ||
        review.Author.UserId === this.getUserId ||
        review.Transient.IsLiked !== 0) return false;
      return true;
    },

    canAnswerComment(comment) {
      if (!this.isObjectAuthor || typeof comment.Transient.Answer !== 'undefined') return false;
      return true;
    },

    submitCommentAnswer() {
      const inputs = this.$refs.inputs;
      if (!inputs.hasErrors()) {
        this.sendingToApi = true;
        const values = inputs.getValues();
        const params = {};
        params.ObjectId = this.answerPopup.objectId;
        params.Text = values.reviewText;
        params.Grade = 0;
        params.Type = 'comment';
        params.ParentReviewId = this.answerPopup.questionId;
        axios.post('users/validatePassword', values.password).then(() => {
          axios.post('reviews', params).then(() => {
            this.$message({
              message: 'Ответ на комментарий отправлен',
            });
            this.$emit('onUpdateComment');
            this.$refs.inputs.clearValues();
            this.answerPopup.showAnswerPopup = false;
          }).catch((error) => {
            if (error.response && error.response.data) {
              if (error.response.data.length) {
                this.$message({
                  message: error.response.data[0],
                  showClose: true,
                  duration: 5000,
                });
              }
            }
          }).finally(() => {
            this.sendingToApi = false;
          });
        }).catch((error) => {
          this.$message(error.response.data);
          this.sendingToApi = false;
        });
      }
    },

    date(t) {
      return this.timeToDate(t);
    },

    submitReviewRelation(reviewId, grade, relationButton) {
      if (this.getUserId) {
        this.sendingToApi = true;
        this.activeRelationButton = relationButton;
        const params = {};
        params.Grade = grade;
        axios.put(`likes/reviews/${reviewId}/${this.getUserId}`, params).then(() => {
          this.$message({
            message: 'Оценка учтена',
          });
          this.$emit('onUpdateReview');
          this.sendingToApi = false;
          this.activeRelationButton = null;
        }).catch((error) => {
          if (error.response && error.response.data) {
            if (error.response.data.length) {
              this.$message({
                message: error.response.data[0],
                showClose: true,
                duration: 5000,
              });
            }
          }
          this.sendingToApi = false;
          this.activeRelationButton = null;
        });
      }
    },

    addCommentAnswer(comment) {
      this.answerPopup.objectId = comment.ObjectId;
      this.answerPopup.questionId = comment.ReviewId;
      this.answerPopup.questionText = comment.Text;
      this.answerPopup.showAnswerPopup = true;
    },

    getReviewType(review) {
      if (review.Type === 'review') return 'Review';
      return 'Comment';
    },

    showManageDialog(review, action) {
      this.sendingToApi = false;
      this.manageReview.ObjectId = review.ObjectId;
      this.manageReview.ReviewId = review.ReviewId;
      this.manageReview.ParentReviewId = review.ParentReviewId;
      this.manageReview.Text = review.Text;
      this.manageReview.Grade = review.Grade;
      this.manageReview.Type = review.Type;
      if (review.Type === 'review') this.manageReview.TypeName = 'отзыв';
      else if (review.Type === 'comment') this.manageReview.TypeName = 'комментарий';
      else this.manageReview.TypeName = '';
      if (action === 'delete') this.manageReview.deleteDialogVisible = true;
      else if (action === 'edit') {
        this.manageReview.editDialogVisible = true;
        this.$nextTick(() => {
          this.$refs.reviewText.setValue(review.Text);
          if (review.Type === 'review') this.$refs.reviewGrade.setValue(review.Grade);
        });
      }
    },

    deleteReview() {
      if (this.manageReview.ReviewId && this.canDeleteReview) {
        this.sendingToApi = true;
        axios.delete(`reviews/${this.manageReview.ReviewId}`).then(() => {
          const reviewTypeCapital = this.manageReview.TypeName.charAt(0).toUpperCase() +
            this.manageReview.TypeName.substr(1);
          this.$message.success(`${reviewTypeCapital} удален`);
        }).catch((error) => {
          const respError = error.response.data;
          this.$message.closeAll();
          this.$message({
            type: 'error',
            message: respError,
            duration: 7000,
          });
        }).finally(() => {
          if (this.manageReview.Type === 'review') this.$emit('onUpdateReview');
          else if (this.manageReview.Type === 'comment') this.$emit('onUpdateComment');
          this.sendingToApi = false;
          this.manageReview.deleteDialogVisible = false;
        });
      }
    },

    updateReview() {
      if (this.manageReview.ReviewId && this.canUpdateReview) {
        const inputs = this.$refs.inputs;
        if (!inputs.hasErrors()) {
          const values = inputs.getValues();
          const params = {};
          params.ObjectId = this.manageReview.ObjectId;
          params.ReviewId = this.manageReview.ReviewId;
          params.Text = values.reviewText;
          params.ParentReviewId = this.manageReview.ParentReviewId;
          if (this.manageReview.Type === 'review') {
            params.Grade = values.reviewGrade;
          }
          params.Type = this.manageReview.Type;
          /* if (params.Type === 'review' && params.Text.length < 100) {
            this.$message({
              message: 'Минимальная длина отзыва должна составлять 100 символов',
              showClose: true,
              duration: 5000,
            });
            return;
          }
          if (params.Type === 'comment' && params.Text.length < 10) {
            this.$message({
              message: 'Минимальная длина комментария должна составлять 10 символов',
              showClose: true,
              duration: 5000,
            });
            return;
          } */
          this.sendingToApi = true;
          axios.put(`reviews/${this.manageReview.ReviewId}`, params).then(() => {
            const reviewTypeCapital = this.manageReview.TypeName.charAt(0).toUpperCase() +
              this.manageReview.TypeName.substr(1);
            this.$message.success(`${reviewTypeCapital} обновлен`);
            this.$refs.inputs.clearValues();
          }).catch((error) => {
            const respError = error.response.data;
            this.$message.closeAll();
            this.$message({
              type: 'error',
              message: respError,
              duration: 7000,
            });
          }).finally(() => {
            if (this.manageReview.Type === 'review') this.$emit('onUpdateReview');
            else if (this.manageReview.Type === 'comment') this.$emit('onUpdateComment');
            this.manageReview.editDialogVisible = false;
            this.sendingToApi = false;
          });
        }
      }
    },

  },

};
</script>

<style lang="scss">
@import "../../styles/common/main";

.el-dialog {
  .dialog-primary-btn.send-claim-inactive:disabled,
  .dialog-primary-btn.send-claim-inactive:disabled:hover {
    opacity: 0.2;
    cursor: not-allowed;
  }
  .dialog-message {
    color: #fff;
    padding-bottom: 20px;
  }
  .rp_header {
    text-align: center;
  }
}

.review_rw {
  .rw_no-reviews {
    padding-bottom: 20px;
  }
  .rw_claim-add {
    float: right;
    margin: 0px 15px 0 0;
  }
  .rw_item {
    overflow: hidden;
    background: $blocks-bg;
    padding: 20px;
    margin-bottom: 20px;
    .rw-delete,
    .rw-edit,
    .rw-add-claim {
      width: 24px;
      height: 24px;
      float: right;
      margin-top: 5px;
      margin-right: 17px;
      cursor: pointer;
    }
    .rw-delete {
      background: 0 0 no-repeat url(/static/grx/icons/delete.svg);
      &:hover {
        background-image: url(/static/grx/icons/delete-hover.svg);
      }
    }
    .rw-edit {
      background: 0 0 no-repeat url(/static/grx/icons/edit.svg);
      &:hover {
        background: 0 0 no-repeat url(/static/grx/icons/edit-hover.svg);
      }
    }
    .rw-add-claim {
      background: 0 0 no-repeat url(/static/grx/icons/claim.svg);
      &:hover {
        background-image: url(/static/grx/icons/claim-hover.svg);
      }
    }
    .rw_inner-wrap {
      @include clearfix;
    }
    .rw_author {
      text-decoration: underline;
      cursor: pointer;
      float: left;
      margin-right: 10px;
      padding-top: 2px;
    }
    .rw_author:hover {
      text-decoration: none;
      color: #e58ab1;
    }
    .rw_date {
      color: #b2b2b2;
      padding-top: 2px;
    }
    .rw-grade {
      display: inline-block;
      clear: both;
      float: left;
      width: 35px;
      height: 28px;
    }
    .rw-content {
      overflow: hidden;
      .rw_text{
        overflow: hidden;
        margin-top: 10px;
      }
    }
    .rw-likes-control{
      width: auto;
      min-width: 50px;
      float: right;
      .rw-set-like,
      .rw-set-dislike {
        width: 10px;
        height: 10px;
        display: inline-block;
        cursor: pointer;
        vertical-align: middle;
      }
      .rw-set-like {
        background: 0 0 no-repeat url(/static/grx/icons/rw-set-like.svg);
      }
      .rw-set-dislike {
        background: 0 0 no-repeat url(/static/grx/icons/rw-set-dislike.svg);
      }
      .rw-set-like:hover {
        background-image:url(/static/grx/icons/relation-set-pos.svg);
      }
      .rw-set-dislike:hover {
        background: 0 0 no-repeat url(/static/grx/icons/relation-set-neg.svg);
      }
      .send_relation_wait,
      .send_relation_wait:hover {
        background: 0 0 no-repeat url(/static/grx/icons/relation-waiting.gif);
      }
      .rw-likes-count{
        display: inline-block;
        width:auto;
        min-width: 20px;
        text-align: center;
        vertical-align: middle;
      }
      .negative-review-rating{
        color: rgba(215, 66, 120, 1);
      }
      .positive-review-rating{
        color: rgba(149, 195, 2, 1);
      }
      .neutral-review-rating{
        color: #999;
      }
      .no-likes-control{
        width: auto;
        min-width: 50px;
      }
      .rw-defined-like,
      .rw-defined-dislike
      {
        width: 10px;
        height: 10px;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
  .rw-positive{
    border-top:12px solid rgba(149, 195, 2, .1);
    .rw-grade{
      background: 0 0 no-repeat url(/static/grx/icons/rw-positive.svg);
    }
  }
  .rw-negative{
    border-top:12px solid rgba(215, 66, 120, .1);
    .rw-grade{
      background: 0 0 no-repeat url(/static/grx/icons/rw-negative.svg);
    }
  }
  .rw-comment{
    border-top:12px solid rgba(153, 153, 153, 0.1);
    .btn-answer-comment {
      padding: 5px;
      margin-left: 30px;
      border-radius: 10px;
      cursor: pointer;
      color: #b2b2b2;
      background-color: rgba(153, 153, 153, 0.1);
    }
    .comment-answer {
      padding-left: 30px;
      padding-top: 10px;
      .author-link {
        text-decoration: underline;
        cursor: pointer;
      }
      .author-link:hover {
        text-decoration: none;
        color: #e58ab1;
      }
    }
  }
  &.theme-w {
    .rw_item {
      background: transparent !important;
    }
  }
  .rs_popup_rp{
    .comment-question{
      color:#FFF;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/review/AppReviewsList.vue